export const ESTADO_CUENTA = {
  PENDIENTE: 0,
  REVISANDO: 1,
  VALIDADA: 2,
  RECHAZADA: 3,
} as const

export type EstadoCuentaType =
  (typeof ESTADO_CUENTA)[keyof typeof ESTADO_CUENTA]
